import { useFormContext } from 'react-hook-form';

import { DisplayRefDisplayType } from '@repo/sdk/models/components';

import { settingsInputMap } from '@/features/equipment-browser/equipment-details/settings/maps/settings-inputs.map';
import { SubcomponentAttributeConfig } from '@/features/equipment-browser/equipment-details/state/related-devices.state';
import { EnhancedReading } from '@/features/equipment-browser/subscriptions/use-get-readings-values';
import { EnhancedSetting } from '@/features/equipment-browser/subscriptions/use-get-settings-values';
import { Stack } from '@/ux-common/components/stack/stack';

import { EquipmentDetailsMetricLabel } from '../metrics/equipment-details-metric-label';

type SubcomponentAttributeProps = {
  attribute: SubcomponentAttributeConfig;
};

const SettingAttribute = ({ setting }: { setting: EnhancedSetting }): React.ReactNode => {
  const form = useFormContext();
  const SettingInput = settingsInputMap[setting.displayType ?? DisplayRefDisplayType.Input];

  return (
    <Stack key={`setting-attribute-${setting.ref.id}`} className="stack-sm">
      <SettingInput form={form} setting={setting} name={`settings.${setting.ref.id}`} />
    </Stack>
  );
};

export const SubcomponentAttribute = ({
  attribute,
}: SubcomponentAttributeProps): React.ReactNode => {
  return (
    <Stack key={`subcomponent-attribute-${attribute.type}`} className="stack-sm">
      {attribute.type === 'reading' ? (
        <EquipmentDetailsMetricLabel reading={attribute.reading as EnhancedReading} />
      ) : (
        <SettingAttribute setting={attribute.setting as EnhancedSetting} />
      )}
    </Stack>
  );
};
